"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryListControlledExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/query-list/examples/controlled.ts';
var countryQueryList = _1.QueryList.ofType();
var QueryListControlledExample = /** @class */ (function () {
    function QueryListControlledExample() {
        var _this = this;
        this.activeIndex = 5;
        this.query = 'Al';
        this.handleSelect = function (item) {
            _this.selectedItem = item;
        };
        this.handleActiveItemChange = function (_item, index) {
            _this.activeIndex = index;
        };
        this.handleQueryChange = function (query) {
            _this.query = query;
        };
        this.resetAll = function () {
            _this.activeIndex = 0;
            _this.selectedItem = undefined;
            _this.query = '';
        };
    }
    QueryListControlledExample.prototype.view = function () {
        var _this = this;
        var resetButton = (0, mithril_1.default)(_1.Tooltip, {
            content: 'Reset',
            trigger: (0, mithril_1.default)(_1.Button, {
                iconLeft: _1.Icons.REFRESH_CW,
                onclick: this.resetAll
            }),
            size: 'xs'
        });
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(countryQueryList, {
                activeIndex: this.activeIndex,
                contentRight: resetButton,
                items: examples_1.countries,
                itemPredicate: this.itemPredicate,
                itemRender: function (item) { return (0, mithril_1.default)(_1.ListItem, {
                    label: item.name,
                    selected: _this.selectedItem === item,
                    key: item.code
                }); },
                inputAttrs: {
                    contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.SEARCH }),
                    autofocus: true,
                    index: 0,
                    placeholder: 'Search countries...'
                },
                onActiveItemChange: this.handleActiveItemChange,
                onQueryChange: this.handleQueryChange,
                onSelect: this.handleSelect,
                listAttrs: { style: 'height:300px; width:300px' },
                query: this.query
            })
        ]);
    };
    QueryListControlledExample.prototype.itemPredicate = function (query, item) {
        return item.name.toLowerCase().includes(query.toLowerCase());
    };
    QueryListControlledExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)(_1.Button, {
                label: 'Query = "Canada"',
                onclick: function () { return _this.query = 'Canada'; },
                size: 'xs',
                style: 'margin-bottom: 5px'
            }),
            (0, mithril_1.default)(_1.Button, {
                label: 'Index to "10"',
                onclick: function () { return _this.activeIndex = 10; },
                size: 'xs'
            })
        ];
    };
    return QueryListControlledExample;
}());
exports.QueryListControlledExample = QueryListControlledExample;
